import { costTrackerFields } from 'src/enums/cost-tracker';
import { getColumnWidths } from 'src/common/table/column-utils';
import { getFields } from './get-ct-fields';

const columnWidthGroup = {
  minimum: [
    costTrackerFields.COST_TYPE,
    costTrackerFields.COST_AFE,
    costTrackerFields.COST_SUGGESTED,
    costTrackerFields.COST_ACTUAL,
    costTrackerFields.VARIANCE,
  ],
  maximum: [costTrackerFields.NAME, costTrackerFields.START, costTrackerFields.FINISH],
};

const getFieldWidth = (field: costTrackerFields) => {
  if (columnWidthGroup.minimum.includes(field)) {
    return 1;
  }
  if (columnWidthGroup.maximum.includes(field)) {
    return 2;
  }
  return 0.3;
};

export const getColumnWidth = (disabledFields: string[] = []) => {
  const fields = getFields(disabledFields);
  return getColumnWidths(fields, getFieldWidth, costTrackerFields.NAME);
};
